import * as React from "react";
const SvgArrowRight = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	id: "arrow-right_icon",
	...props
}, /* @__PURE__ */ React.createElement("path", { d: "M23.987 12a2.41 2.41 0 0 0-.814-1.8L11.994.361a1.44 1.44 0 0 0-1.9 2.162l8.637 7.6a.25.25 0 0 1-.165.437H1.452a1.44 1.44 0 0 0 0 2.88h17.111a.251.251 0 0 1 .165.438l-8.637 7.6a1.44 1.44 0 1 0 1.9 2.161L23.172 13.8a2.4 2.4 0 0 0 .815-1.8" }));
export { SvgArrowRight as ReactComponent };
